import type { ConversationHistoryTranscriptCommonModelOutput } from "@elevenlabs/elevenlabs-js/api";

/**
 * Takes a transcript from ElevenLabs and transforms it into
 * a simple text representation which we'll use to summarize.
 */
export const transformTranscriptToString = (transcript: ConversationHistoryTranscriptCommonModelOutput[]): string => {
  return transcript.map((item) => `${item.role}: ${item.message ?? ""}`).join("\n\n");
};

// All other conversation utilities have been moved to @rebuild/shared
// Import them from there:
// import {
//   ConversationType,
//   ConversationInputParams,
//   getConversationInputParams,
//   getMostRecentEquipmentCountSummary,
//   getCurrentEquipmentPerRoomContext
// } from '@rebuild/shared';
